// Tremor Badge [v1.0.0]

import { cx } from '@/lib/utils'

type BadgeColor = 'gray' | 'blue' | 'secondary' | 'green' | 'yellow' | 'red' | 'purple' | 'orange'

interface BadgeProps {
  color?: BadgeColor
  children: React.ReactNode
  className?: string
}

const colorStyles: Record<BadgeColor, string> = {
  gray: 'bg-gray-50 text-gray-900 ring-gray-500/30',
  // "blue" predates the primary/secondary rebrand — it maps to primary (now an orange/red), not
  // an actual blue. Kept as-is for existing callers that genuinely want the primary color under
  // this name; anything that wants the actual blue ("Rolla Blue") should use "secondary" instead.
  blue: 'bg-primary-50 text-primary-900 ring-primary-500/30',
  secondary: 'bg-secondary-50 text-secondary-900 ring-secondary-500/30',
  green: 'bg-emerald-50 text-emerald-900 ring-emerald-600/30',
  yellow: 'bg-yellow-50 text-yellow-900 ring-yellow-600/30',
  red: 'bg-red-50 text-red-900 ring-red-600/20',
  purple: 'bg-purple-50 text-purple-900 ring-purple-600/30',
  orange: 'bg-orange-50 text-orange-900 ring-orange-600/30',
}

export function Badge({ color = 'gray', children, className }: BadgeProps) {
  return (
    <span
      className={cx(
        'inline-flex items-center gap-x-1 whitespace-nowrap rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset',
        colorStyles[color],
        className,
      )}
    >
      {children}
    </span>
  )
}

export function SmallBadge({ color = 'gray', children, className }: BadgeProps) {
  return (
    <span
      className={cx(
        'inline-flex items-center rounded px-1.5 py-0.5 text-[10px] font-medium ring-1 ring-inset',
        colorStyles[color],
        className,
      )}
    >
      {children}
    </span>
  )
}
